import React, { FC, useState, useEffect } from 'react';
import { Media } from '@montana/shared/media';
import { epiMediaRatioToEnum } from '@montana/helpers/epi-mapping.helper';
import { RichText } from '@montana/shared/rich-text';
import { IM09ShopTheLookGalleryItem, IM19ShopTheLookBundleCardBlock } from '@montana/models/generated/cms.interface';
import { Button, ButtonStyles } from '@montana/shared/button';
import { useTranslations } from '@montana/containers/translations';
import { formatString } from '@montana/helpers/string-format/string-format.helper';
import { useSettings } from '@montana/containers/settings/settings.container';

export const M09ShopTheLookGalleryBlockItem: FC<IM09ShopTheLookGalleryItem & { position?: number }> = (props: IM09ShopTheLookGalleryItem & { position?: number }) => {

    const {
        image,
        video,
        mediaDisplayRatio,
        width,
        content,
        position,
        contentCards,
    } = props;
    const translate = useTranslations();
    const { market } = useSettings();
    const [bundle, setBundle] = useState<IM19ShopTheLookBundleCardBlock | undefined>();

    // Set position and width of item inside the css grid
    const styles = position ? { gridColumn: `${position} / span ${width}` } : {};

    useEffect(() => {
        const contentCard = !!contentCards?.length && contentCards[0];
        if (contentCard) {
            setBundle(contentCard);
        }
    }, [contentCards]);

    return (
        <div className="shop-the-look-gallery-block-item" style={styles}>
            {!!(bundle?.image || video || image) && (
                <Media
                    className="shop-the-look-gallery-block-item__media"
                    image={!!bundle?.image ? bundle.image : image}
                    video={!!bundle ? undefined : video}
                    mediaRatio={epiMediaRatioToEnum(mediaDisplayRatio)}
                    placeholder
                />
            )}

            {!!bundle && (
                <div className="stl-bundle shop-the-look-gallery-block-item__content">
                    {!bundle.isComposition && (
                        <p className="stl-bundle__product-label">
                            {translate(t => t.productPage.shopTheLookProductLabel, '[Product]')}
                        </p>
                    )}
                    <h5 className="stl-bundle__product-title">{bundle.title}</h5>
                    {!!content && (
                        <div className="stl-bundle__rte-content">
                            <RichText text={content} disableAppear />
                        </div>
                    )}
                    {!market?.hidePrices && (
                        <p className="stl-bundle__product-price">
                            {bundle.isComposition && bundle.price?.priceWithDiscount?.formattedWithCurrency}
                            {!bundle.isComposition && `${translate((translations): string => translations.filterAndSearch.from, "From")} ${bundle.cheapestPrice?.formattedWithCurrency}`}
                        </p>
                    )}
                    <Button
                        style={ButtonStyles.Primary}
                        href={bundle.link?.url}
                        title={bundle.link?.title}
                    >
                        {bundle.isComposition && translate(t => t.productPage.shopTheLookShopComposition, '[Shop the composition]')}
                        {!bundle.isComposition && formatString(translate(t => t.productPage.shopTheLookShopProduct, '[Shop {0}]'), bundle.title || '')}
                    </Button>
                </div>
            )
            }

            {
                !bundle && !!content && (
                    <div className="shop-the-look-gallery-block-item__content">
                        <RichText text={content} />
                    </div>
                )
            }
        </div >
    );
}
